module.exports = __webpack_public_path__ + "static/media/envelope-square.5a6ce336.svg";